(() => {
  const blurProperty = gsap.utils.checkPrefix('backdropFilter');
  const blurExp = /blur\((.+)?px\)/;
  const getBlurMatch = (target) => (gsap.getProperty(target, blurProperty) || '').match(blurExp) || [];

  gsap.registerPlugin({
    name: 'backdropFilterBlur',
    get(target) {
      return +(getBlurMatch(target)[1]) || 0;
    },
    init(target, endValue) {
      const data = this;
      let filter = gsap.getProperty(target, blurProperty);
      let mutEndValue = endValue;
      const endBlur = `blur(${mutEndValue}px)`;
      const match = getBlurMatch(target)[0];
      let index;
      if (filter === 'none') {
        filter = '';
      }
      if (match) {
        index = filter.indexOf(match);
        mutEndValue = filter.substr(0, index) + endBlur + filter.substr(index + match.length);
      } else {
        mutEndValue = filter + endBlur;
        filter += filter ? ' blur(0px)' : 'blur(0px)';
      }
      data.target = target;
      data.interp = gsap.utils.interpolate(filter, mutEndValue);
    },
    render(progress, data) {
      // eslint-disable-next-line no-param-reassign
      data.target.style[blurProperty] = data.interp(progress);
    },
  });
})();
